<template>
  <VueSelect
    :options="options"
    :label="label"
    :reduce="reduce"
    :selectable="selectable"
    :value="value"
    :disabled="disabled"
    :placeholder="placeholder"
    :clearable="clearable"
    :searchable="searchable"
    @input="($event) => $emit('input', $event)"
    @option:created="($event) => $emit('option:created', $event)"
    @search:blur="($event) => $emit('search:blur', $event)">
    <template v-slot:no-options="props">
      <slot name="no-options" v-bind="props">
        <div class="py-2 text-14px leading-16px">Ничего не найдено</div>
      </slot>
    </template>
    <template v-slot:open-indicator="props">
      <slot name="open-indicator" v-bind="props">
        <span class="arrow arrow-b"></span>
      </slot>
    </template>
    <template v-slot:option="props">
      <slot name="option" v-bind="props">
        <div class="flex items-center">
          <Attachment
          v-if="icons"
          class="w-18px h-full object-cover object-center mr-6"
          :id="props.name"/>
          <span class="text-14px leading-16px">{{ $delve(props, label) }}</span>
        </div>
      </slot>
    </template>
    <template v-slot:selected-option="props">
      <slot name="selected-option" v-bind="props">
        <div class="flex items-center">
          <Attachment
          v-if="icons"
          class="w-18px h-full object-cover object-center mr-6"
          :id="props.name"/>
            <span class="text-14px leading-16px">{{ $delve(props, label) }}</span>
        </div>
      </slot>
    </template>
  </VueSelect>
</template>

<script>
import VueSelect from 'vue-select';
import Attachment from '@/components/global/Attachment.vue';

export default {
  name: 'Select',
  components: {
    VueSelect,
    Attachment,
  },
  props: {
    value: {
      type: [Object, Array, Number],
      required: false,
      default: () => {},
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    icons: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: 'label',
    },
    reduce: {
      type: Function,
      required: false,
      default: (option) => option,
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
